import styled from 'styled-components';

export const TopbarWrapper = styled.div`
    position: relative;
    display: flex;
    flex: 1 1 auto;
    height:42px;
    align-items: center;
    width: 100%;
    padding: 10px 15px;
    z-index: 49;
    // border-radius: 5px;
    background:rgba(${ props => props.topbarBg.r }, ${ props => props.topbarBg.g }, ${ props => props.topbarBg.b }, ${ props => props.topbarBg.a });
    // box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
    border-bottom:1px solid rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });

    .menu-icon{
        flex-shrink: 0;
        display: none;
    }

    .menu-icon span{
        font-size: 32px;
    }

    .spacer{
        display: flex;
        flex: 1 1 auto;
        height: 1px;
    }

    .info-header{
        display: flex;
        align-items: center;
    }
    
    .contact-suppport-layout{
        margin-right: 13px;
        line-height: 1;
        cursor: pointer;
    }
    .contact-suppport-layout span{
        color:rgba(${ props => props.iconColor.r }, ${ props => props.iconColor.g }, ${ props => props.iconColor.b }, ${ props => props.iconColor.a });
        font-size:27px;
        margin-top:2px;
    }
    .info-layout-wrapper{
        margin-right: 10px;
        border:1px solid transparent;
    }
    .info-layout-wrapper:hover{
        border:1px solid rgba(${ props => props.iconColor.r }, ${ props => props.iconColor.g }, ${ props => props.iconColor.b }, ${ props => props.iconColor.a });
        border-radius: 100%;
    }
    .topbar-info-layout{
        margin: 2px;
        cursor: pointer;
        border-radius: 100%;
        background:rgba(${ props => props.iconColor.r }, ${ props => props.iconColor.g }, ${ props => props.iconColor.b }, ${ props => props.iconColor.a });
        display: flex;
        align-items: center;
        padding: 4px;
    }
    .topbar-info-layout img{
        height:16px;
        width:16px;
        padding: 0px;
    }
    .header-notification-wrapper{
        position: relative;
    }
    .header-notification{
        width:30px;
        height:30px;
        text-align: center;
        color:rgba(${ props => props.badgeTextColor.r }, ${ props => props.badgeTextColor.g }, ${ props => props.badgeTextColor.b }, ${ props => props.badgeTextColor.a });
    }
    .header-notification:hover{
        border-radius: 100%;
        background:rgba(${ props => props.selectedIconBg.r }, ${ props => props.selectedIconBg.g }, ${ props => props.selectedIconBg.b }, ${ props => props.selectedIconBg.a });
    }
    .header-notification span{
        font-size: 26px;
        line-height: 1.2;
        padding:0px;
        color:rgba(${ props => props.iconColor.r }, ${ props => props.iconColor.g }, ${ props => props.iconColor.b }, ${ props => props.iconColor.a });
    }
    .notification-all-col a{
        padding: 10px;
        display:block;
        font-size: 14px;
        color:rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
        font-weight: 600;
    }
    .notification-all-col a:hover{
        color:rgba(${ props => props.themeHoverTextColor.r }, ${ props => props.themeHoverTextColor.g }, ${ props => props.themeHoverTextColor.b }, ${ props => props.themeHoverTextColor.a });
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
    }
    .noti-badge{
        position: absolute;
        background: rgba(${ props => props.badgeBg.r }, ${ props => props.badgeBg.g }, ${ props => props.badgeBg.b }, ${ props => props.badgeBg.a });
        border-radius: 100%;
        width: 15px;
        line-height: 11px;
        height: 15px;
        right: 0px;
        top:0px;
        text-align: center;
    }
    .noti-badge span{
        font-size: 8px !important;
        display: inline-block;
        color:rgba(${ props => props.badgeTextColor.r }, ${ props => props.badgeTextColor.g }, ${ props => props.badgeTextColor.b }, ${ props => props.badgeTextColor.a });
        font-weight:600;
        padding: 0px !important;
    }
    .vertical-line{
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
        width: 1px;
        height: 30px;
        margin-left: 15px;
    }
    .ams-logo img{
        height: 18px;
        margin-left: 20px;
    }

    .info-header-wrapper{
        display: flex;
        align-items: center;
    }
    .noti-list-item{
        position: relative;
        display: flex;
        align-items: center;
    }
    .noti-list-item > a:first-child{
        flex: 1;
        min-width: 0;
    }
    .noti-list-item .noti-content{
        flex: 1;
    }
    a.noti-reminder-icon{
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding: 0 8px 0 4px !important;
        background: transparent !important;
        opacity: 0;
        pointer-events: none;
    }
    .noti-list-item:hover a.noti-reminder-icon{
        opacity: 1;
        pointer-events: auto;
    }
    a.noti-reminder-icon span{
        font-size: 16px !important;
        color: #aaa !important;
        cursor: pointer;
        transition: color 0.2s;
    }
    a.noti-reminder-icon:hover span{
        color: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a }) !important;
    }
    a.noti-reminder-icon:hover::after{
        content: attr(data-title);
        background-color: rgba(${ props => props.iconColor.r }, ${ props => props.iconColor.g }, ${ props => props.iconColor.b }, ${ props => props.iconColor.a });
        color: #fff;
        padding: 7px;
        border-radius: 4px;
        font-size: 11px;
        font-weight: bold;
        line-height: 14px;
        display: block;
        position: absolute;
        top: 100%;
        bottom: auto;
        right: 0;
        margin-top: 6px;
        white-space: nowrap;
        z-index: 300;
    }
    .reminder-popup{
        position: absolute;
        right: 0;
        top: calc(100% + 8px);
        width: 280px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0px 8px 28px rgba(0,0,0,0.22);
        z-index: 300;
    }
    .reminder-popup-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 14px;
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
        border-radius: 8px 8px 0 0;
    }
    .reminder-popup-header p{
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
    }
    .reminder-close{
        font-size: 18px !important;
        color: #fff !important;
        cursor: pointer;
    }
    .reminder-popup-body{
        padding: 14px;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .reminder-popup-body label{
        font-size: 13px;
        font-weight: 500;
        color: #555;
        margin-bottom: 2px;
    }
    .reminder-time-row{
        display: flex;
        gap: 8px;
    }
    .reminder-time-col{
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .reminder-popup-body .dropdown-menu{
        max-height: 160px;
        overflow-y: auto;
        min-width: unset;
        width: 100%;
    }
    .reminder-time-col .dropdown-menu{
        max-height: 160px;
        overflow-y: auto;
        min-width: unset;
        width: 100%;
    }
    .reminder-days-input{
        width: 100%;
        padding: 2px 8px;
        height: 28px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 13px;
        color: #333;
        outline: none;
        box-sizing: border-box;
        -moz-appearance: textfield;
    }
    .reminder-days-input::-webkit-outer-spin-button,
    .reminder-days-input::-webkit-inner-spin-button{
        -webkit-appearance: none;
        margin: 0;
    }
    .reminder-days-input:focus{
        border-color: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
    }
    .reminder-fields-disabled{
        opacity: 0.4;
        pointer-events: none;
        user-select: none;
    }
    .reminder-custom-checkbox{
        display: flex;
        align-items: center;
        gap: 6px;
        margin: 8px 0 4px;
        input[type="checkbox"]{
            width: 14px;
            height: 14px;
            cursor: pointer;
            margin: 0;
        }
        label{
            margin: 0;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
        }
    }
    .reminder-error{
        color: #e53935;
        font-size: 11px;
        margin: -4px 0 0;
    }
    .reminder-success{
        color: #2e7d32;
        font-size: 11px;
        margin: 0;
    }
    .reminder-popup-footer{
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 10px 14px;
        border-top: 1px solid #eee;
        border-radius: 0 0 8px 8px;
    }
    .reminder-cancel-btn{
        padding: 6px 14px;
        border: 1px solid #ccc;
        background: #fff;
        border-radius: 4px;
        font-size: 13px;
        cursor: pointer;
        outline: none;
    }
    .reminder-save-btn{
        padding: 6px 14px;
        border: none;
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
        color: #fff;
        border-radius: 4px;
        font-size: 13px;
        cursor: pointer;
        outline: none;
    }
    .reminder-save-btn:disabled{
        opacity: 0.6;
        cursor: not-allowed;
    }
    /* Bottom-right reminder list popup */
    .reminder-list-fab-wrapper{
        position: fixed;
        bottom: 24px;
        right: 24px;
        z-index: 1000;
    }
    .reminder-list-popup{
        width: 340px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.18);
    }
    .reminder-list-popup > *:first-child{
        border-radius: 10px 10px 0 0;
    }
    .reminder-list-popup > *:last-child{
        border-radius: 0 0 10px 10px;
    }
    .reminder-list-popup-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 11px 14px;
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
        cursor: default;
    }
    .reminder-list-header-left{
        display: flex;
        align-items: center;
        gap: 2px;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
    }
    .reminder-count-badge{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: rgba(255,255,255,0.25);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        border-radius: 10px;
        min-width: 20px;
        height: 18px;
        padding: 0 5px;
        margin-left: 6px;
    }
    .reminder-list-header-actions{
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .reminder-list-clear-all{
        font-size: 11px;
        font-weight: 600;
        color: rgba(255,255,255,0.85);
        cursor: pointer;
        border: 1px solid rgba(255,255,255,0.4);
        border-radius: 4px;
        padding: 2px 7px;
        white-space: nowrap;
        transition: all 0.15s;
    }
    .reminder-list-clear-all:hover{
        background: rgba(255,255,255,0.15);
        color: #fff;
    }
    .reminder-list-minimize{
        font-size: 18px !important;
        color: #fff !important;
        cursor: pointer;
        opacity: 0.85;
    }
    .reminder-list-minimize:hover{
        opacity: 1;
    }
    .reminder-list-popup-list{
        max-height: 360px;
        overflow-y: auto;
    }
    .reminder-list-popup-list ul{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .reminder-card-item{
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 11px 14px;
        border-bottom: 1px solid #f2f2f2;
        cursor: pointer;
        transition: background 0.15s;
    }
    .reminder-card-item:last-child{
        border-bottom: none;
    }
    .reminder-card-item:hover{
        background: #f8f6fb;
    }
    .reminder-card-body{
        flex: 1;
        min-width: 0;
    }
    .reminder-card-top{
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 6px;
    }
    .reminder-card-name{
        font-size: 13px;
        font-weight: 600;
        color: #222;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .reminder-card-desc{
        margin: 2px 0 0;
        font-size: 12px;
        color: #666;
        line-height: 1.4;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .reminder-card-actions{
        display: flex;
        gap: 6px;
        max-height: 0;
        overflow: hidden;
        margin-top: 0;
        opacity: 0;
        pointer-events: none;
        transition: max-height 0.2s ease, opacity 0.15s, margin-top 0.2s;
    }
    .reminder-card-item:hover .reminder-card-actions,
    .reminder-card-actions--visible{
        max-height: 40px !important;
        margin-top: 8px !important;
        opacity: 1 !important;
        pointer-events: auto !important;
    }
    .reminder-again-btn{
        flex: 1;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, 0.08);
        border: 1px solid rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, 0.3);
        border-radius: 4px;
        cursor: pointer;
        outline: none;
        transition: background 0.15s;
    }
    .reminder-again-btn:hover{
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, 0.15);
    }
    .reminder-ok-btn{
        flex: 1;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: 500;
        color: #fff;
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
        border: none;
        border-radius: 4px;
        cursor: pointer;
        outline: none;
        transition: opacity 0.15s;
    }
    .reminder-ok-btn:hover{
        opacity: 0.85;
    }
    .remind-again-overlay{
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.3);
        z-index: 1100;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .remind-again-popup{
        width: 300px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.22);
        overflow: hidden;
    }
    .remind-again-popup-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 14px;
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
    }
    .remind-again-popup-header p{
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
    }
    .remind-again-popup-body{
        padding: 14px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .remind-again-label{
        font-size: 12px;
        font-weight: 500;
        color: #555;
        margin-bottom: 2px;
    }
    .remind-again-popup-footer{
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 10px 14px;
        border-top: 1px solid #eee;
    }
    .remind-again-cancel-btn{
        padding: 6px 14px;
        border: 1px solid #ccc;
        background: #fff;
        border-radius: 4px;
        font-size: 13px;
        cursor: pointer;
        outline: none;
    }
    .remind-again-save-btn{
        padding: 6px 14px;
        font-size: 13px;
        font-weight: 600;
        color: #fff;
        background: rgba(${ props => props.themeColor.r }, ${ props => props.themeColor.g }, ${ props => props.themeColor.b }, ${ props => props.themeColor.a });
        border: none;
        border-radius: 4px;
        cursor: pointer;
        outline: none;
    }
    .remind-again-save-btn:disabled{
        opacity: 0.45;
        cursor: not-allowed;
    }
`;